import { TWidget } from 'widgets/Widget';

/**
 * @param Widget Base widget for extending
 * @returns EmitBusEvent widget
 */
function EmitBusEventClassCreator(Widget: TWidget) {
    /**
     * @category widgets
     * @subcategory global
     * @class EmitBusEvent
     * @augments Widget
     * @classdesc Could be used to trigger any global event using interaction element
     * <br>Could be useful to emit global events like `page.show.globalmodal` to notify
     * <br>concerned widgets, so they could change page layout class etc.
     * <br>Event emission could happens mostly on UI elements like links, buttons etc.
     * @property {string} data-widget - Widget name `emitBusEvent`
     * @property {string} data-bus-event-type - Global event type, which should be triggered
     * @property {string} data-event-click - Event listener to trigger `emitBusEvent` method
     * @property {string} data-url - any kind of additional properties
     *
     * @example <caption>Example of EmitBusEvent widget usage</caption>
     * <button
     *     data-widget="emitBusEvent"
     *     data-bus-event-type="dialogshow"
     *     data-event-click.prevent="emitBusEvent"
     *     data-modal-config='{
     *         "url": "${URLUtils.url('Page-LocaleContent')}",
     *         "headerText": "${Resource.msg('form.countrySelector.title', 'forms', null)}"
     *     }'
     * >
     *     ... content
     * </button>
     */
    class EmitBusEvent extends Widget {
        prefs() {
            return {
                busEventType: '',
                ...super.prefs()
            };
        }

        /**
         * @description Emit event
         */
        emitBusEvent() {
            if (this.prefs().busEventType) {
                this.eventBus().emit(this.prefs().busEventType, this);
            }
        }
    }

    return EmitBusEvent;
}

export type TEmitBusEvent = ReturnType<typeof EmitBusEventClassCreator>;

export type TEmitBusEventInstance = InstanceType<TEmitBusEvent>;

export default EmitBusEventClassCreator;
